import { render } from "./WelcomeComponent.vue?vue&type=template&id=1ef6de1e&scoped=true"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js"

import "./WelcomeComponent.vue?vue&type=style&index=0&id=1ef6de1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef6de1e"]])

export default __exports__